import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ManageSearch from "@material-ui/icons/ManageSearch";
import React from "react";
import useButtonShowLog from "./hooks/useButtonShowLog";
import { LogItemButtonShowFC } from "./types";

const LogItemButtonShow: LogItemButtonShowFC = ({ logId }) => {
  const { isDisabled, handlerClick } = useButtonShowLog(logId);
  return (
      <Tooltip title={"Просмотр"}>
        <span>
              <IconButton
                  size={"small"}
                  color={"primary"}
                  onClick={handlerClick}
                  disabled={isDisabled}
              >
                <ManageSearch/>
              </IconButton>
        </span>
      </Tooltip>
  );
};

export default LogItemButtonShow;
